const Toggle = {
    init() {
        document.addEventListener('click', event => {
            const trigger = event.target.closest('[data-toggle-target]');
            if (!trigger) return;

            const name = trigger.dataset.toggleTarget;
            handleToggle(name, trigger);
        });
    },
};

function handleToggle(name, triggerElement) {
    document.querySelectorAll('[data-toggle-name]').forEach(el => el.style.display = 'none');
    document.querySelectorAll(`[data-toggle-name="${name}"]`).forEach(el => el.style.display = '');
    document.querySelectorAll('[data-toggle-target]').forEach(el => el.classList.remove('active'));
    triggerElement.classList.add('active');
}

export default Toggle;
